<iframe
  class="position-fixed inset-0 tube-overlay-view full-width full-height"
  [class.d-none]="!isVisible()"
  [class.pointer-events-none]="!isVisible()"
  [src]="(environment.tubeUrl + '?identity=' + terminalsStore.selectedTerminal()?.screenerIdentity) | safe:'resourceUrl'"
  frameborder="0"
  #tubeIframeEl
></iframe>
